import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true, // send the session cookie on every request
  timeout: 60000,
});

// Redirect to the login page on any 401 response
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Publish a custom event so AuthProvider can react without a hard dependency
      window.dispatchEvent(new CustomEvent("ledgerly:unauthenticated"));
    }
    return Promise.reject(err);
  },
);
